<template>
  <NuxtLayout></NuxtLayout>
</template>
<script setup lang="ts">

</script>
<style lang="scss" scoped>

</style>